











import Vue from "vue";
import Component from "vue-class-component";
import AppHeader from '@/components/layout/AppHeader.vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import TitleBar from '@/components/layout/TitleBar.vue';
import Loading from '@/components/layout/Loading.vue';
import store from "@/store";

@Component({
  store,
  components: {AppFooter, AppHeader, TitleBar, Loading}
})
export default class App extends Vue {
}
